import { render, staticRenderFns } from "./ShelfConfiguration.vue?vue&type=template&id=4116d8a2&"
import script from "./ShelfConfiguration.vue?vue&type=script&lang=js&"
export * from "./ShelfConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ShelfConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
